var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "navigationPlaceholder" } },
      [
        _c("WorkspaceNavigation", {
          attrs: {
            workspaceId: _vm.$route.params.id,
            workspaceName: "Workspace",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid", staticStyle: { "margin-top": "50px" } },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12" }, [
            _setup.model
              ? _c("div", { staticStyle: { margin: "30px" } }, [
                  !_setup.error
                    ? _c("div", [
                        _c("h2", { staticClass: "text-center" }, [
                          _vm._v("Summary Report"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "lead text-center" }, [
                          _vm._v(
                            "Region: " +
                              _vm._s(_setup.regionName) +
                              ", Voting cycle: " +
                              _vm._s(_setup.votingCycle)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Board Ranking"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            { staticClass: "table table-bordered table-hover" },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(
                                    _setup.boardRanking.Header.Headers,
                                    function (header) {
                                      return _c(
                                        "th",
                                        { staticClass: "text-center" },
                                        [_vm._v(_vm._s(header))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _setup.boardRanking.Rows,
                                  function (row) {
                                    return _c(
                                      "tr",
                                      _vm._l(row.Values, function (val) {
                                        return _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(val))]
                                        )
                                      }),
                                      0
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Overall Board Scoring Statistics"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("table", [
                          _c("tr", [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_setup.totalPossibleScore)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_setup.boardHighScore)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_setup.boardAverage)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            { staticClass: "table table-bordered table-hover" },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(
                                    _setup.overallBoardScoringStatistics.Header
                                      .Headers,
                                    function (header) {
                                      return _c(
                                        "th",
                                        { staticClass: "text-center" },
                                        [_vm._v(_vm._s(header))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _setup.overallBoardScoringStatistics.Rows,
                                  function (row) {
                                    return _c(
                                      "tr",
                                      _vm._l(row.Values, function (val) {
                                        return _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(val))]
                                        )
                                      }),
                                      0
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Rating Ratios"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _setup.ratingRatios
                            ? _c("div", { staticClass: "table-responsive" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-bordered table-hover",
                                  },
                                  [
                                    _c("thead", [
                                      _c(
                                        "tr",
                                        _vm._l(
                                          _setup.ratingRatios.Header.Headers,
                                          function (header) {
                                            return _c(
                                              "th",
                                              { staticClass: "text-center" },
                                              [_vm._v(_vm._s(header))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _setup.ratingRatios.Rows,
                                        function (row) {
                                          return _c(
                                            "tr",
                                            _vm._l(row.Values, function (val) {
                                              return _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [_vm._v(_vm._s(val) + "%")]
                                              )
                                            }),
                                            0
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                      ])
                    : _vm._e(),
                ])
              : _c("div", { staticStyle: { margin: "30px" } }, [
                  _c("h1", [_vm._v(_vm._s(_setup.error))]),
                ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("strong", [_vm._v("Total Possible Score:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("strong", [_vm._v("Board High Score:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("strong", [_vm._v("Board Average:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }